import type { TokaMapInstance } from '@tokamap/core';
import buildingPickStore        from '@/TokamapEditor/stores/buildingPickStore';

/** Arme ou range l'outil « ouverture » — partagé par le menu Tracer et le raccourci « O ». */
export default function toggleOpeningTool(instance: TokaMapInstance | null | undefined): void {
	if (!instance) return;

	const { mapAdapter } = instance;

	if (mapAdapter.isDrawingOpening()) return mapAdapter.stopDrawingOpening();

	if (buildingPickStore.active) buildingPickStore.stop();

	return mapAdapter.startDrawingOpening();
}
